import { toast } from 'react-toastify';
import { retrieveUnifiedError } from '@/api/utils';
import { useGetInvoice } from '@/queries/quotes';
import { Uuid } from '@/api/types';

export const useOpenInvoice = (caseId: Uuid) => {
  const { mutateAsync: getInvoice } = useGetInvoice();

  const openInvoice = (invoiceId: string) => async () => {
    try {
      const blob = await getInvoice({ caseId, documentId: invoiceId });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 100);
    } catch (e) {
      toast.error(retrieveUnifiedError(e).message);
    }
  };

  return openInvoice;
};
